import React from 'react';
import { View, Text, TouchableOpacity, Linking, StyleSheet } from 'react-native';
import { createThemedStyles } from '../theme/useThemedStyles';
import {
  PRIVACY_POLICY_URL,
  TERMS_OF_USE_URL,
} from '../constants/legalLinks';

const openUrl = async (url: string) => {
  const supported = await Linking.canOpenURL(url);
  if (supported) {
    await Linking.openURL(url);
  }
};

const SubscriptionLegalLinks = () => {
  const styles = useStyles();

  return (
    <View style={styles.container}>
      <Text style={styles.title}>Legal</Text>
      <TouchableOpacity
        onPress={() => openUrl(TERMS_OF_USE_URL)}
        accessibilityRole="link"
        accessibilityLabel="Terms of Use"
      >
        <Text style={styles.link}>Terms of Use</Text>
      </TouchableOpacity>
      <TouchableOpacity
        onPress={() => openUrl(PRIVACY_POLICY_URL)}
        accessibilityRole="link"
        accessibilityLabel="Privacy Policy"
      >
        <Text style={styles.link}>Privacy Policy</Text>
      </TouchableOpacity>
    </View>
  );
};

const useStyles = createThemedStyles((colors) =>
  StyleSheet.create({
    container: {
      marginHorizontal: 20,
      marginBottom: 12,
      padding: 16,
      borderRadius: 8,
      backgroundColor: colors.surface,
      alignItems: 'center',
      gap: 8,
    },
    title: {
      fontSize: 14,
      fontWeight: '600',
      color: colors.text.secondary,
      marginBottom: 4,
    },
    link: {
      fontSize: 15,
      color: colors.primary.main,
      textDecorationLine: 'underline',
    },
  })
);

export default SubscriptionLegalLinks;
